import { AdapterRegistry } from 'app/model/adapters/adapter-registry';
import { Model } from 'app/model/backendmodel';

import { } from '../../base/annotation';
import { Metamodel } from 'app/model/base/model';
import { TabularTypeDatasetAdapter, tabularTypeDatasetAdapts } from './tabular-type.dataset.adapter';
import { AmazonRdsForOracleDataset } from 'app/model/dataset/amazon-rds-for-oracle.dataset';

@AdapterRegistry.adapter({
    model: Metamodel.modelFor(AmazonRdsForOracleDataset),
    asynchronous: true,
    adapts: tabularTypeDatasetAdapts
})
export class AmazonRdsForOracleDatasetAdapter extends TabularTypeDatasetAdapter<AmazonRdsForOracleDataset, Model.DatasetResource> {
    protected async _toResource(dataset: AmazonRdsForOracleDataset): Promise<Model.DatasetResource> {
        return await this._toResourceInternal(dataset, AmazonRdsForOracleDataset.MODEL.name);
    }

    protected async _toModel(modelDatasetResource: Model.DatasetResource, dataset?: AmazonRdsForOracleDataset): Promise<AmazonRdsForOracleDataset> {
        return await this._toModelInternal(modelDatasetResource, dataset, AmazonRdsForOracleDataset.MODEL);
    }
}
